import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
    ModalBody, ModalCloseButton, Button, Flex, FormControl,
    FormLabel, Input, FormErrorMessage, Heading, InputGroup,
    InputLeftAddon, NumberInput, NumberInputField, NumberInputStepper,
    NumberIncrementStepper, NumberDecrementStepper, Text, useColorModeValue, useToast
} from "@chakra-ui/react";
import {Controller, useForm} from "react-hook-form";
import {postData} from "../../services/api";
import React, {useState} from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

export default function AddPriceModal({isOpen, onClose, selectedRental, onRentalDateAdded}) {

    const [loading, setLoading] = useState(false);

    const MySwal = withReactContent(Swal);
    const toast = useToast();

    const textColor = useColorModeValue("secondaryGray.900", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");

    const {
        handleSubmit,
        register,
        control,
        setValue,
        formState: {errors},
        reset
    } = useForm({
        defaultValues: {
            date_to: "",
            date_from: "",
            price: 20,
        }
    })

    async function onSubmit(values) {
        try {
            values.type = 'seasonprice';

            setLoading(true)
            const date = await postData(`/api/rentals/${selectedRental.id}/dates`, values);
            setLoading(false)

            onRentalDateAdded(date);

            onClose();
            reset();

            MySwal.fire({
                title: <p>Preis wurde angelegt</p>,
                html: <p>Der Preis wurde erfolgreich angelegt.</p>,
                icon: 'success',
            })

        } catch (error) {
            toast({
                title: 'Der Preis konnte nicht angelegt werden: ' + error.message,
                status: 'error',
                isClosable: true,
            })
            setLoading(false)
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent bgColor="white">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalHeader>Preis hinzufügen</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <FormControl mb='24px'>
                            <FormLabel
                                display='flex'
                                ms='4px'
                                fontSize='sm'
                                fontWeight='500'
                                color={textColor}
                                htmlFor='price'
                            >
                                Preis pro Übernachtung<Text
                                color={brandStars}>*</Text>
                            </FormLabel>
                            <InputGroup>
                                <InputLeftAddon height='auto'>€</InputLeftAddon>
                                <Controller
                                    name="price"
                                    control={control}
                                    render={({field}) => (
                                        <NumberInput
                                            size='lg'
                                            maxW={32}
                                            defaultValue={10}
                                            min={1}
                                            value={field.value}
                                            onChange={(valueAsString, valueAsNumber) => {
                                                setValue('price', valueAsNumber);
                                            }}
                                        >
                                            <NumberInputField
                                                id='price'
                                                fontSize='sm'
                                                type='number'
                                                fontWeight='500'
                                                size='lg'
                                                borderLeftRadius={0}
                                            />
                                            <NumberInputStepper>
                                                <NumberIncrementStepper/>
                                                <NumberDecrementStepper/>
                                            </NumberInputStepper>
                                        </NumberInput>
                                    )}
                                />
                            </InputGroup>
                            <FormErrorMessage>
                                {errors.price && errors.price.message}
                            </FormErrorMessage>
                        </FormControl>
                        <Flex mt={5} gap={5}>
                            <FormControl mb='24px' isInvalid={errors.date_from}>
                                <FormLabel
                                    display='flex'
                                    ms='4px'
                                    fontSize='sm'
                                    fontWeight='500'
                                    color={textColor}
                                    htmlFor='date_from'
                                >
                                    <Heading size="md">Datum von:</Heading>
                                </FormLabel>
                                <Input
                                    id='date_from'
                                    fontSize='sm'
                                    type='date'
                                    fontWeight='500'
                                    size='lg'
                                    {...register('date_from', {
                                        required: 'Bitte geben Sie ein Datum an'
                                    })}
                                />
                                <FormErrorMessage>
                                    {errors.date_from && errors.date_from.message}
                                </FormErrorMessage>
                            </FormControl>
                            <FormControl mb='24px' isInvalid={errors.date_to}>
                                <FormLabel
                                    display='flex'
                                    ms='4px'
                                    fontSize='sm'
                                    fontWeight='500'
                                    color={textColor}
                                    htmlFor='date_to'
                                >
                                    <Heading size="md">Datum bis:</Heading>
                                </FormLabel>
                                <Input
                                    id='date_to'
                                    fontSize='sm'
                                    type='date'
                                    fontWeight='500'
                                    size='lg'
                                    {...register('date_to', {
                                        required: 'Bitte geben Sie ein Datum an'
                                    })}
                                />
                                <FormErrorMessage>
                                    {errors.date_to && errors.date_to.message}
                                </FormErrorMessage>
                            </FormControl>
                        </Flex>
                    </ModalBody>

                    <ModalFooter>
                        <Button variant='ghost' mr={3} onClick={onClose}>
                            Schließen
                        </Button>
                        <Button
                            isLoading={loading}
                            variant={'brand'}
                            type="submit"
                        >
                            Preis hinzufügen
                        </Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
}
